export default "__VITE_ASSET__CwxctPXh__"